import './Home.css';

import Events from '../../containers/past-events/Events';
import About from '../../containers/about/About';
import Header from '../../containers/header/Header';
import Contact from '../../containers/contact/Contact';
import Navbar from '../../components/navbar/Navbar';

function Home() {
  return (
    <div id="home">
      <Navbar />
      <Header />
      <About />
      <Events />
      <Contact />
    </div>
  );
}

export default Home;
